import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect, useContext } from 'react';
import { Checkbox, Form, Header, Icon, List } from 'semantic-ui-react';
import _find from 'lodash/find';
import _map from 'lodash/map';
import { getSelectedModifiers, getFormErrorMessage, getToggleIconHelpText, shouldDisableModifierCheckbox } from './ModifierSetSelection.utils';
import Accordion from '../../../../../foundation/components/Accordion/Accordion';
import { createSelectionRangeDescription, formatModifierPrice } from '../../../../services/modifiers';
import { ItemCartContext } from '../../CatalogItemCart.context';
import './ModifierSetSelection.css';
function ModifierSetSelection(_ref) {
  var modifierListId = _ref.modifierListId;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    modifiers = _useState4[0],
    setModifiers = _useState4[1];
  var _useContext = useContext(ItemCartContext),
    setFormError = _useContext.setFormError,
    loading = _useContext.loading,
    toggleSelectedModifier = _useContext.toggleSelectedModifier,
    allModifierLists = _useContext.modifierLists,
    allModifiers = _useContext.modifiers,
    allSelectedModifiers = _useContext.selectedModifiers;
  var modifierList = _find(allModifierLists, {
    _id: modifierListId
  });
  var name = modifierList.name,
    minAllowed = modifierList.minAllowed,
    maxAllowed = modifierList.maxAllowed,
    modifierIds = modifierList.modifiers;
  var formErrorKey = "modifierList$".concat(modifierListId);
  useEffect(function () {
    var newModifiers = getSelectedModifiers(modifierIds, allModifiers, allSelectedModifiers);
    setModifiers(newModifiers);
    setFormError(formErrorKey, getFormErrorMessage(newModifiers, minAllowed, maxAllowed, name));
  }, [allSelectedModifiers]);
  function toggleExpanded() {
    setIsExpanded(function (prevIsExpanded) {
      return !prevIsExpanded;
    });
  }
  return /*#__PURE__*/React.createElement(Form.Group, {
    className: "modifier-set-selection"
  }, /*#__PURE__*/React.createElement(Accordion, null, /*#__PURE__*/React.createElement(Accordion.Title, {
    active: true,
    onClick: toggleExpanded
  }, /*#__PURE__*/React.createElement(Header, {
    size: "small"
  }, /*#__PURE__*/React.createElement("span", null, "".concat(name, " ").concat(createSelectionRangeDescription(minAllowed, maxAllowed)), /*#__PURE__*/React.createElement(Icon, {
    name: "angle up",
    title: getToggleIconHelpText(isExpanded),
    className: isExpanded ? 'turned-down' : 'turned-up'
  })))), /*#__PURE__*/React.createElement(Accordion.Content, {
    active: isExpanded,
    duration: 500
  }, /*#__PURE__*/React.createElement(List, {
    className: "modifier-selection-checkboxes"
  }, _map(modifiers, function (_ref2) {
    var _ref2$modifier = _ref2.modifier,
      price = _ref2$modifier.price,
      modifierName = _ref2$modifier.name,
      modifierId = _ref2$modifier._id,
      selected = _ref2.selected;
    return /*#__PURE__*/React.createElement(List.Item, {
      key: modifierId
    }, /*#__PURE__*/React.createElement(Form.Field, {
      className: "modifier-selection-checkbox"
    }, /*#__PURE__*/React.createElement(Checkbox, {
      label: modifierName,
      name: "modifier$".concat(modifierId),
      checked: selected,
      disabled: loading || shouldDisableModifierCheckbox(modifiers, selected, maxAllowed),
      onChange: function onChange() {
        return toggleSelectedModifier(modifierId);
      }
    }), /*#__PURE__*/React.createElement("div", null, formatModifierPrice(price, {
      displayZeroCost: true
    }))));
  })))));
}
export default ModifierSetSelection;